import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'terms-and-conditions',
  styleUrls: ['./terms-and-conditions.component.scss'],
  template: `
    <div class="terms-and-conditions-wrap d-flex flex-column text-center text-md-start">
      <div class="mr-sm-min-1" [translate]="'orderProcess.payment.paymentAreProcessedByCakeiteasy'"></div>
      <div
        class="text-underline pointer"
        [translate]="'orderProcess.payment.terms.byCompletingIAccept'"
        (click)="onTermsClick.emit()"
      ></div>
    </div>
  `,
})
export class TermsAndConditionsComponent {
  @Output() onTermsClick = new EventEmitter<void>();
}
